// The verses a section covers, typed the way they are said: "4", "4-11", or
// blank for a section with no passage above it.
import { useEffect, useState } from "react";

export function parseRange(input: string): { startVerse: number | null; endVerse: number | null } | null {
  const raw = input.trim().replace(/[–—]/g, "-");
  if (!raw) return { startVerse: null, endVerse: null };
  const m = /^(\d{1,3})(?:\s*-\s*(\d{1,3}))?$/.exec(raw);
  if (!m) return null;
  const startVerse = Number(m[1]);
  const endVerse = m[2] ? Number(m[2]) : null;
  if (startVerse < 1 || startVerse > 200) return null;
  if (endVerse !== null && (endVerse < startVerse || endVerse > 200)) return null;
  return { startVerse, endVerse };
}

export function formatRange(startVerse: number | null, endVerse: number | null): string {
  if (startVerse === null) return "";
  return endVerse && endVerse > startVerse ? `${startVerse}-${endVerse}` : String(startVerse);
}

export function VerseRangeField({
  startVerse,
  endVerse,
  onChange,
}: {
  startVerse: number | null;
  endVerse: number | null;
  onChange: (range: { startVerse: number | null; endVerse: number | null }) => void;
}) {
  const [text, setText] = useState(() => formatRange(startVerse, endVerse));
  const [bad, setBad] = useState(false);

  useEffect(() => setText(formatRange(startVerse, endVerse)), [startVerse, endVerse]);

  const commit = () => {
    const range = parseRange(text);
    if (!range) return setBad(true);
    setBad(false);
    onChange(range);
  };

  return (
    <label className="flex items-center gap-1.5 text-[11px] tracking-[0.06em] text-ink-3 uppercase">
      Verses
      <input
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          setBad(false);
        }}
        onBlur={commit}
        onKeyDown={(e) => e.key === "Enter" && commit()}
        placeholder="1-3"
        aria-label="Verses covered by this section"
        aria-invalid={bad}
        className={`w-[72px] rounded border bg-paper px-2 py-1 text-center font-sans text-[12px] tracking-normal text-ink normal-case focus-visible:outline-none ${bad ? "border-accent" : "border-rule"}`}
      />
    </label>
  );
}
